// extracted by mini-css-extract-plugin
export default {"cvError":"T1-z"};